import * as http from './http'
import endpoints from './endpoints'
import { CheckoutPageModel } from '@ViewModels/CheckoutPageModel'
import { StoreCheckoutDto } from '@ViewModels/StoreCheckoutDto'
import { CheckoutVerificationResult } from '@ViewModels/CheckoutVerificationResult'
import { CheckoutResponse } from '@ViewModels/CheckoutResponse'

const api = endpoints.checkout
const cartApi = endpoints.cart

export const getModelData = async (useStoreCredit: boolean = false): Promise<CheckoutPageModel> => {
   let url = `${api}`
   if (useStoreCredit) {
      url = `${url}?useStoreCredit=true`
   }
   return http.get(url)
}

export const verifyCheckout = async (
   dto: StoreCheckoutDto
): Promise<CheckoutVerificationResult> => {
   const url = `${api}/verify`
   return (await http.post(url, dto)) as CheckoutVerificationResult
}

export const completeCheckout = async (dto: StoreCheckoutDto): Promise<CheckoutResponse> => {
   const url = `${api}`
   return (await http.post(url, dto)) as CheckoutResponse
}

export const setShippingCountryId = async (countryId: string): Promise<CommitResult> => {
   const url = `${cartApi}/country/${countryId}`
   return (await http.post(url, {})) as CommitResult
}

export const setDeliveryMethod = async (clickAndCollect: boolean): Promise<CommitResult> => {
   const url = `${cartApi}/clickandcollect/${clickAndCollect}`
   return (await http.post(url, {})) as CommitResult
}

export const addPromocode = async (code: string): Promise<CommitResult> => {
   const url = `${cartApi}/promocodes?code=${code}`
   return (await http.post(url, {}, false)) as CommitResult
}

export const removePromocode = async (code: string): Promise<CommitResult> => {
   const url = `${cartApi}/promocodes/${code}`
   return (await http.del(url)) as CommitResult
}

export const logAnalytics = async (data: any): Promise<CommitResult> => {
   const url = `${cartApi}/analytics`
   return (await http.post(url, data)) as CommitResult
}

export const redirectToOrder = (result: CheckoutResponse, isLoggedIn: boolean) => {
   if (!result.Success) {
      return
   }
   let url = `/Store/Order/Detail/${result.OrderId}`
   if (isLoggedIn) {
      url = `/Store/Order/Detail/${result.OrderNumber}`
   }
   window.location.href = url
}
